export default __webpack_public_path__ + "static/map-indicator-174d8eeb9f501ab0d1ec09b4fb939479.svg";